/**
 * Creates a safe function wrapper that only executes if the input is a function
 * @param fn - The function to call.
 * @param args - The arguments to pass to the function.
 * @returns The result of the function call or undefined if the function is not defined.
 */
export const safeCall = <T extends (...args: any[]) => any>(
  fn: T | undefined,
  ...args: Parameters<T>
): ReturnType<T> | undefined => {
  if (typeof fn === 'function') {
    return fn(...args);
  }
  return undefined;
};
